export default {
  name: "Notification",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28.86 24.48c-1.56-2.59-2.29-5.67-2.98-8.63-1.24-5.26-2.53-10.68-8.88-11.2V3a1 1 0 0 0-1-1 1 1 0 0 0-1 1v1.65c-6.48.51-7.72 5.93-8.92 11.2-.67 2.97-1.37 6.04-2.93 8.63-.42.64.1 1.54.85 1.52h7.1a5 5 0 0 0 9.8 0H28c.75.02 1.27-.88.86-1.52zM16 28c-1.3 0-2.4-.84-2.82-2h5.63A2.99 2.99 0 0 1 16 28zM5.67 24c1.17-2.46 1.77-5.12 2.36-7.7C9.44 10.1 10.5 6.6 16 6.6c5.38 0 6.47 3.51 7.93 9.71.61 2.58 1.23 5.23 2.4 7.69H5.67z",
  },
}
